import { createSlice } from '@reduxjs/toolkit'

import { baseModelState, updateExtraReducers, openForm, closeForm } from 'store/common'
import api from './api'


const initialState = {
  ...baseModelState,
}


export const card = createSlice({
  name: 'card',
  initialState,
  reducers: {
    openForm,
    closeForm,
  },
  extraReducers: (builder) => {
    updateExtraReducers(builder, api.endpoints.updateCard);
  },
});

export default card.reducer;

export const CardActions = card.actions;
